var _g, _path, _g2, _path2, _g3, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnboarding3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 486,
    height: 281,
    viewBox: "0 0 486 281",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    d: "M474.48 3.72998H11.51C7.08068 3.72998 3.49001 7.32066 3.49001 11.75V253.25C3.49001 257.679 7.08068 261.27 11.51 261.27H474.48C478.909 261.27 482.5 257.679 482.5 253.25V11.75C482.5 7.32066 478.909 3.72998 474.48 3.72998Z",
    fill: "url(#paint0_linear_263_9975)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M474 0H12C5.36 0 0 5.38 0 12V249.96C0 262.68 10.31 273 23.04 273H474C480.62 273 486 267.64 486 261V12C486 5.38 480.62 0 474 0ZM482 253C482 257.42 478.42 261 474 261H12C7.58 261 4 257.42 4 253V12C4 7.58 7.58 4 12 4H474C478.42 4 482 7.58 482 12V253Z",
    fill: "url(#paint1_linear_263_9975)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_263_9975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.43 264.63H225.56C224.395 264.63 223.45 265.575 223.45 266.74V266.9C223.45 268.065 224.395 269.01 225.56 269.01H260.43C261.595 269.01 262.54 268.065 262.54 266.9V266.74C262.54 265.575 261.595 264.63 260.43 264.63Z",
    fill: "#C61F2F"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116.61 179.43V249.96C116.61 253.96 115.59 257.72 113.8 261C113.74 261.09 113.69 261.19 113.63 261.28C109.68 268.28 102.18 273 93.57 273H23.04C10.31 273 0 262.68 0 249.96V179.43C0 174.96 1.27 170.78 3.49 167.25C3.65 166.99 3.82 166.73 4 166.47C8.14 160.38 15.12 156.39 23.04 156.39H93.57C106.29 156.39 116.61 166.7 116.61 179.43Z",
    fill: "url(#paint2_linear_263_9975)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.57 158.39C105.17 158.39 114.61 167.83 114.61 179.43V249.96C114.61 253.46 113.73 256.92 112.08 259.98C112.05 260.03 112.02 260.08 111.99 260.13L111.97 260.16L111.93 260.22L111.89 260.28C108.16 266.88 101.15 270.98 93.57 270.98H23.04C11.44 270.98 2 261.54 2 249.94V179.41C2 175.45 3.1 171.61 5.19 168.28C5.33 168.05 5.48 167.82 5.65 167.58C9.57 161.82 16.07 158.38 23.04 158.38H93.57M93.57 156.39H23.04C15.12 156.39 8.14 160.38 4 166.47C3.82 166.73 3.65 166.99 3.49 167.25C1.27 170.78 0 174.96 0 179.43V249.96C0 262.68 10.31 273 23.04 273H93.57C102.18 273 109.68 268.28 113.63 261.28C113.69 261.19 113.74 261.09 113.8 261C115.59 257.72 116.61 253.96 116.61 249.96V179.43C116.61 166.7 106.29 156.39 93.57 156.39Z",
    fill: "#F6F6F6"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M47.6 225.4C45.46 223.26 41.99 223.26 39.85 225.4C38.19 227.06 37.17 232.01 36.81 234.07L36.36 236.64L38.93 236.19C40.98 235.82 45.94 234.8 47.6 233.15C48.67 232.08 49.2 230.68 49.2 229.27C49.2 227.86 48.67 226.47 47.6 225.4ZM74.75 192.75C66.81 193.01 58.94 198.74 50.69 210.25C48.65 213.39 46.89 216.7 45.43 220.14H46.46C49.98 220.16 52.84 223.01 52.85 226.54V227.56C56.3 226.11 59.61 224.35 62.75 222.32C74.28 214.05 80 206.16 80.25 198.21C80.25 194.37 78.7 192.75 74.75 192.75ZM64.72 212.84C62.2 212.84 60.16 210.79 60.16 208.27C60.16 205.75 62.2 203.71 64.72 203.71C67.24 203.71 69.29 205.75 69.29 208.27C69.29 210.79 67.25 212.84 64.72 212.84ZM64.88 225.28C61.07 227.74 57.04 229.84 52.85 231.56V236.58H54.68C59.9 236.64 64.71 233.77 67.15 229.16C68.25 226.93 68.93 224.51 69.14 222.03C67.81 223.11 66.39 224.19 64.88 225.28ZM43.84 205.84C39.23 208.28 36.36 213.1 36.42 218.32V220.14H41.44C43.16 215.95 45.26 211.93 47.71 208.12C48.8 206.61 49.88 205.19 50.96 203.85C48.49 204.07 46.07 204.74 43.84 205.84Z",
    fill: "#F6F6F6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M251.95 42.8201L329.4 87.6601V177.34L251.95 222.18L174.5 177.34V87.6601L251.95 42.8201ZM251.95 156.96C265.46 156.96 276.41 146.01 276.41 132.5C276.41 118.99 265.46 108.04 251.95 108.04C238.44 108.04 227.49 118.99 227.49 132.5C227.49 146.01 238.44 156.96 251.95 156.96Z",
    fill: "url(#paint3_linear_263_9975)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_263_9975",
    x: 215.45,
    y: 260.63,
    width: 55.09,
    height: 20.3799,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.8 0 0 0 0 0.0705882 0 0 0 0 0.0823529 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_263_9975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_263_9975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_263_9975",
    x1: 3.49001,
    y1: 132.5,
    x2: 482.5,
    y2: 132.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F071F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#200613"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200508"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_263_9975",
    x1: 0,
    y1: 136.5,
    x2: 486,
    y2: 136.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#200508"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#110304"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_263_9975",
    x1: 58.3,
    y1: 162.53,
    x2: 58.3,
    y2: 262.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09090E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12121B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_263_9975",
    x1: 251.95,
    y1: 59.7801,
    x2: 251.95,
    y2: 206.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFB5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6B5BB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboarding3);
export default __webpack_public_path__ + "static/media/onboarding_3.f0cd995ee9e4e71119b57194ae3eeb31.svg";
export { ForwardRef as ReactComponent };